import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { GaugeBase } from './GaugeBase';
import { ILoggerService } from '../../services';

class GaugeWidgetController extends GaugeBase implements angular.IComponentController {
   
    static $inject = ['$scope', 'loggerService'];

    constructor($scope: angular.IScope,
        loggerService: ILoggerService) {
        super($scope, loggerService);
    }

    $onInit() {
        super.$onInit();
    }
}

export const wtGaugeWidget: ComponentDefinition = {
    componentId: 'wtGaugeWidget',
    controller: GaugeWidgetController,
    template: require('./gaugeWidget.component.html'),
    controllerAs: 'vm',
    bindings: {
        datasource: '<',
        item: '<'
    }
};
